import { gql, MutationHookOptions, useMutation } from "@apollo/client";
import {
  CompanyMinimalFragment,
  COMPANY_MINIMAL_FRAGMENT,
} from "../../fragments";
import { UpdateCompanyMutationVariables } from "../../types";

export const UPDATE_COMPANY = gql`
  mutation updateCompany($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      company {
        ...CompanyMinimalFragment
      }
    }
  }
  ${COMPANY_MINIMAL_FRAGMENT}
`;

export type CompanyData = {
  updateCompany: { company: CompanyMinimalFragment };
};

export default (
  options?: MutationHookOptions<CompanyData, UpdateCompanyMutationVariables>
) => {
  return useMutation<CompanyData, UpdateCompanyMutationVariables>(
    UPDATE_COMPANY,
    options
  );
};
